/* global BX, bitrix_sessid, FormUtils */

(function () {
    'use strict';
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;

    const modalId = 'vacancy-modal-overlay';
    const closeBtnId = 'vacancy-modal-close-btn';
    const submitBtn = document.getElementById('vacancy-submit-btn');
    const commonErrorsBlock = document.getElementById('vacancy-form-common-errors');
    const captchaContainerId = 'vacancy-captcha-container';
    const containerSelector = '#vacancy-modal-content';

    const fullname = document.getElementById('vacancy-fullname');
    const position = document.getElementById('vacancy-desired-position');
    const phone = document.getElementById('vacancy-phone');
    const email = document.getElementById('vacancy-email');
    const message = document.getElementById('vacancy-message');
    const fileInput = document.getElementById('vacancy-file');
    const fileBtn = document.getElementById('vacancy-file-btn');
    const fileText = document.getElementById('vacancy-file-text');

    if (!document.getElementById(modalId) || !submitBtn) return;

    FormUtils.setupPhoneMask(phone);
    FormUtils.setupFileButton(fileBtn, fileInput, fileText);

    const initCaptcha = () => FormUtils.initCaptcha(captchaContainerId);
    const resetCaptcha = () => FormUtils.resetCaptcha();

    const clearFields = () => {
        fullname.value = '';
        position.value = '';
        phone.value = '';
        email.value = '';
        message.value = '';
        if (fileInput) fileInput.value = '';
        if (fileText) fileText.textContent = 'ничего не выбрано';
    };

    const hideErrors = () => {
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };

    const validate = () => {
        let isValid = true;
        hideErrors();

        if (!FormUtils.validateRequired(fullname.value)) {
            FormUtils.showFieldError(fullname, '*Обязательное поле');
            isValid = false;
        }

        if (!FormUtils.validateRequired(position.value)) {
            FormUtils.showFieldError(position, '*Обязательное поле');
            isValid = false;
        }

        const phoneDigits = phone.value.replace(/\D/g, '');
        if (!FormUtils.validateRequired(phone.value)) {
            FormUtils.showFieldError(phone, '*Обязательное поле');
            isValid = false;
        } else if (!FormUtils.validatePhoneDigits(phoneDigits)) {
            FormUtils.showFieldError(phone, '*Введите корректный номер телефона (не менее 10 цифр)');
            isValid = false;
        }

        if (!FormUtils.validateRequired(email.value)) {
            FormUtils.showFieldError(email, '*Обязательное поле');
            isValid = false;
        } else if (!FormUtils.validateEmail(email.value)) {
            FormUtils.showFieldError(email, '*Введите корректный E-mail');
            isValid = false;
        }

        if (!FormUtils.validateRequired(message.value)) {
            FormUtils.showFieldError(message, '*Обязательное поле');
            isValid = false;
        }

        if (!fileInput || fileInput.files.length === 0) {
            FormUtils.showFieldError(fileInput, '*Прикрепите файл резюме');
            isValid = false;
        } else {
            const file = fileInput.files[0];
            const allowedExtensions = ['pdf', 'doc', 'docx', 'txt', 'rtf'];
            const ext = file.name.split('.').pop().toLowerCase();
            if (!allowedExtensions.includes(ext)) {
                FormUtils.showFieldError(fileInput, '*Допустимые форматы: pdf, doc, docx, txt, rtf');
                isValid = false;
            } else if (file.size > 10 * 1024 * 1024) {
                FormUtils.showFieldError(fileInput, '*Размер файла не должен превышать 10 МБ');
                isValid = false;
            }
        }

        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, 'Подтвердите, что вы не робот');
            isValid = false;
        }

        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };

    const send = async () => {
        if (!validate()) return;

        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const token =
            typeof bitrix_sessid === 'function' ? bitrix_sessid() : BX.bitrix_sessid ? BX.bitrix_sessid() : '';

        const payload = {
            fullname: fullname.value,
            desired_position: position.value,
            phone: phone.value,
            email: email.value,
            message: message.value,
            smart_token: captchaToken ? captchaToken.value : '',
        };

        if (submitBtn) submitBtn.disabled = true;

        try {
            await FormUtils.sendFormData({
                url: '/api/v1/form/send-resume',
                payload,
                files: [{fieldName: 'resume_file', fileInputElement: fileInput}],
                headers: {
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest',
                },
                submitBtn,
                commonErrorsBlock,
                containerSelector,
                onSuccess: (result) => {
                    alert(result.message || 'Резюме отправлено!');
                    close();
                },
                onFieldError: (field, msg) => {
                    const el = document.getElementById('vacancy-' + field);
                    if (el) FormUtils.showFieldError(el, msg);
                    else if (field === 'resume_file' || field === 'file') {
                        FormUtils.showFieldError(fileInput, msg);
                    }
                },
            });
        } finally {
            if (submitBtn) submitBtn.disabled = false;
        }
    };

    const open = (vacancyTitle = '') => {
        document.getElementById(modalId).style.display = 'flex';
        document.body.style.overflow = 'hidden';
        if (position) position.value = vacancyTitle;
        hideErrors();
        initCaptcha();
        resetCaptcha();
    };

    const close = () => {
        document.getElementById(modalId).style.display = 'none';
        document.body.style.overflow = '';
        clearFields();
        hideErrors();
        resetCaptcha();
    };

    FormUtils.createModal({
        modalId,
        closeBtnId,
        openBtnSelector: '.vacancy-panel__btn',
        onOpen: (btn) => {
            const panel = btn.closest('.accordion-panel');
            const titleElement = panel ? panel.querySelector('.accordion-panel__title') : null;
            const title = titleElement ? titleElement.textContent.trim() : '';
            open(title);
        },
        onClose: close,
    });

    submitBtn.addEventListener('click', send);
})();
